import React, { Component } from 'react'
import { Link } from 'gatsby'
import UserLinks from '../UserLinks'
import config from '../../../data/SiteConfig'
import GetNavList from '../Navigation/NavList'
import GetSocialList from '../Navigation/SocialList'
import logo from '../../../static/images/activelamp-logo-white.svg'
import './Footer.scss'

class Footer extends Component {
  render() {
    const url = config.siteRss
    const { userLinks } = this.props
    const { copyright, fixedFooter } = config
    if (!copyright) {
      return null
    }
    return (
      <footer className={fixedFooter ? 'footer footer-fixed' : 'footer'}>
        <div className="footer-diagonals" />
        {userLinks ? <UserLinks config={config} labeled /> : null}
        <div className="footer-container">
          <div className="navigation-container grid grid-columns">
            <div className="logo-img width-4/12 width-12/12@sm">
              <Link to="/" rel="home" title="Home">
                <img
                  src={logo}
                  alt="ActiveLAMP Logo"
                  title="ActiveLAMP Logo"
                  id="logo"
                  data-scroll-alt={logo}
                />
              </Link>
            </div>
            <div className="footer-menu width-8/12 width-12/12@sm">
              {GetNavList(config).map((value, index) => {
                return (
                  <Link key={index} to={value.to} alt={value.primaryText}>
                    {value.primaryText}
                  </Link>
                )
              })}
            </div>
          </div>
          <div className="footer-details grid grid-columns">
            <div className="address-container width-3/12 width-6/12@sm">
              <span className="address-location">Los Angeles</span>
              <span className="street-address">
                12655 W. Jefferson Blvd, Suite 400
                <br />
                Los Angeles, CA 90066
              </span>
              <span className="phone">
                <a href="tel:+13109430246">
                  <i className="fa fa-phone"></i> 1 310-943-0246
                </a>
              </span>
            </div>
            <div className="address-container width-3/12 width-6/12@sm">
              <span className="address-location">Idaho</span>
              <span className="street-address">
                620 Fremont Ave
                <br />
                Rupert, ID 83350
              </span>

              <span className="phone">
                <a href="tel:+12087541024">
                  <i className="fa fa-phone"></i> 1 208-754-1024
                </a>
              </span>
            </div>

            <div className="social-container width-6/12 width-12/12@sm">
              {GetSocialList(config).map((value, index) => {
                return (
                  <a
                    key={index}
                    href={value.to}
                    target="_blank"
                    alt={value.primaryText}
                  >
                    {value.leftIcon}
                  </a>
                )
              })}
            </div>
          </div>
          <div className="notice-container">
            <div className="copyright">
              <span>{copyright}</span>  &nbsp; &rarr; &nbsp; <a href="/privacy.html">Privacy Policy</a>  &nbsp; &rarr; &nbsp; <a href="/terms.html">Terms of Service</a>
            </div>

            <div className="email">
              <a href="mailto:info@activelamp.com">info@activelamp.com</a>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
